import { getUserState } from "store/slices/Auth/authSlice";

import { useAppSelector } from "../store";

export function useUser() {
  return useAppSelector(getUserState);
}
